module.exports = __webpack_public_path__ + "img/event_wristband.19c48fd2.svg";